export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/service', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getServiceList = async (searchText) => {
    try {
        const result = await get(`service${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getServiceContent = async (newsId) => {
    try {
        const result = await get(`service/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createService = async (data) => {
    try {
        const result = await post('service', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateService = async (id, data) => {
    try {
        const result = await put(`service/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteService = async (id) => {
    try {
        const result = await destroy(`service/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`service/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};
